import type { Estate } from '@/features/estates-property/api/estate';
import { api, extractData } from '@/lib/treaty';

export const getImages = (id: Estate['id']) => {
  return extractData(api.estates({ id }).images.get());
};
